import type { PublicSlotKey } from '#packages/apilib';
import type { TextClassificationApi } from './textClassificationApi';

export const TextClassificationApiKey: PublicSlotKey<TextClassificationApi> = {
  name: 'TextClassificationApi',
  public: true,
};
